function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenBackgroundImage = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _SVG = require("../SVG");
var _styles = require("../../styles");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["color1", "color2", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var _imageWidth = 423;
var BackgroundImage = (0, _react.memo)(function (_ref) {
  var color1 = _ref.color1,
    color2 = _ref.color2,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _jsxRuntime.jsxs)(_SVG.SVG.Svg, Object.assign({
    viewBox: "0 0 423 375",
    style: [{
      width: (0, _styles.getREM)(_imageWidth / _styles.baseSize),
      height: (0, _styles.getREM)(375 / _styles.baseSize),
      flexShrink: 0
    }, style]
  }, props, {
    fill: "none",
    'aria-hidden': true,
    children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      id: "bottom",
      d: "M424 0H0V364.985H75.1741C93.0508 364.985 127.429 364.985 157.682 370.466C187.935 375.946 218.331 368.5 238.5 368.5C258.669 368.5 285.5 375 310 375C329.117 375 364.519 364.985 372.203 364.985H401.539H424V0Z",
      fill: color2
    }), (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      id: "top",
      d: "M424 0H0V339.438H33C45.9106 339.438 81.6639 345.438 98.9518 345.438C118.3 345.438 130.172 346.703 150.362 345.438C170.553 344.172 176.089 345.438 192.5 345.438C213.5 345.438 227.481 339.438 244 339.438C260.519 339.438 288.878 348.012 312.5 339.438C338.5 330 373.983 339.438 388.208 339.438H424V0Z",
      fill: color1
    })]
  }));
});
var ScreenBackgroundImage = exports.ScreenBackgroundImage = (0, _react.memo)(function (_ref2) {
  var color1 = _ref2.color1,
    color2 = _ref2.color2;
  var _useWindowDimensions = (0, _utils.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var _slices = Math.ceil(width / _imageWidth);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    sizing = _STYLES$useStyles.sizing;
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    testID: "ScreenBackgroundImage",
    style: Object.assign({}, _reactNative.StyleSheet.absoluteFillObject, {
      bottom: (0, _styles.getREM)(sizing.headerPaddingBottom / _styles.baseSize),
      backgroundColor: color1
    }),
    children: (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: Object.assign({}, _reactNative.StyleSheet.absoluteFillObject, {
        marginBottom: (0, _styles.getREM)(-sizing.headerPaddingBottom / _styles.baseSize),
        justifyContent: 'flex-end'
      }),
      children: (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: Object.assign({}, _reactNative.StyleSheet.absoluteFillObject, {
          alignItems: 'flex-end',
          flexDirection: 'row'
        }),
        children: new Array(_slices).fill('').map(function (_, index) {
          return (0, _jsxRuntime.jsx)(BackgroundImage, {
            testID: "BackgroundImage-".concat(index),
            color1: color1,
            color2: color2
          }, "header-bg-image-".concat(index));
        })
      })
    })
  });
});